export default __webpack_public_path__ + "static/OpenSans-Regular-db17febda8028538bcee8ad91961b9f9.woff2";